<div class="container renovation-container mt-5 pb-4">
    <div class="row justify-content-center">
        <div class="col-md-12 col-sm-12 col-10">
            <h2 class="text-center mb-4">HISTÓRICO RENOVACIONES</h2>
            <div class="table-responsive-container position-relative">
                <div class="table-responsive mb-5">
                    <table class="table table-borderless table-hover">
                        <tbody *ngIf="dataHistoricRenovations && dataHistoricRenovations.length > 0">
                        <tr *ngFor="let dataRenovation of dataHistoricRenovations | paginate: paginatorConfig,
                        let i = index">
                            <td class="text-center font-weight-bold" scope="row">Nº Contrato {{ dataRenovation.numeroContrato }}</td>
                            <td class="text-center">Título del contrato</td>
                            <td class="text-center">Renovado el {{dataRenovation.fechaRecompraRenovacion | date: "dd/MM/yyyy" }}</td>
                            <td class="text-center">
                                <button class="btn btn-small btn-primary btn-bill" (click)="downLoadBill(dataRenovation.codFacturaRenovacion, btnBill.id, dataRenovation.numeroContrato)" #btnBill [attr.id]="'btn-bill-'+i">
                                    FACTURA<fa-icon [icon]="faDownload"></fa-icon>
                                </button>
                            </td>
                            <td class="text-center">
                                <button class="btn btn-small btn-primary mb-md-0 mb-3 btn-contract" (click)="downLoadContract(dataRenovation.codContrato, btnContract.id, dataRenovation.numeroContrato)"
                                        #btnContract [attr.id]="'btn-contract-'+i">
                                  CONTRATO <fa-icon [icon]="faDownload"></fa-icon>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <app-loader *ngIf="showLoader"></app-loader>
                    <div class="text-center font-weight-bold">{{noHistoricRenovationText}}</div>
                </div>
      
            </div>
            <app-custom-paginator *ngIf="dataHistoricRenovations && dataHistoricRenovations.length != 0" [elementsArray]="dataHistoricRenovations"
                                  [paginationConfig]="paginatorConfig"></app-custom-paginator>
        </div>
    </div>
</div>
<app-modal [attr.id]="modalId" [modalId]="modalId" class="d-none">
    <div
        class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
    </div>
</app-modal>

